import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Institution } from 'src/app/domain/institution';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InstitutionService {
  constructor(private _http: HttpClient) {}

  searchInstitute(search: string): Observable<Institution[]> {
    return this._http.get<Institution[]>(`${environment.apiUrl}${search}`);
  }
}
